<div style="display: flex;justify-content: center;" *ngIf = "!RouteForget">
  <mat-card style="width: max-content">
    <mat-card-header
      style="justify-content: center; background-color: ghostwhite"
    >
      <mat-card-title>
        <span style="text-align: center;">
          <img
            alt="Logo"
            src="assets/images/TLS_Logo.png"
            style="height: 32px; margin-top: 9px; display: block; margin: auto;"
          />
        </span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="margin-top: 3%; margin-bottom: 1%">
      <div>
        <div *ngIf="errorMessage" style="display: flex;
        justify-content: center;
        margin: 3%;" class = "text-danger">
          {{ errorMessage }}
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">
          <mat-form-field
            appearance="outline"
            style="width: 477px; margin-bottom: 10px"
          >
            <input matInput formControlName="username" placeholder="username" />
            <mat-icon matPrefix style="border-right: groove ; margin-right: 20px !important; margin-left: 10px !important; padding: 5px !important;"
              >person</mat-icon
            >
            <mat-error *ngIf="loginForm.controls.username.errors?.required">
              Required
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field
            appearance="outline"
            style="width: 477px; margin-bottom: 10px"
          >
            <input
              matInput
              formControlName="password"
              type="{{ passwordType }}"
              placeholder="Password"
            />
            <mat-icon matPrefix style="border-right: groove; margin-right: 20px !important; margin-left: 10px !important; padding: 5px !important;"
              >vpn_key</mat-icon
            >
                <mat-icon matSuffix style="cursor: pointer; color: grey; margin-right: 45px; padding: 16px !important;" (click)="setPasswordType()"
                  >{{passwordType === 'password' ? 'visibility' : 'visibility_off'}}</mat-icon
                >
            <mat-error *ngIf="loginForm.controls.password.errors?.required">
              Required
            </mat-error>
          </mat-form-field>
          <div style="display: flex; justify-content: center">
            <button
              type="submit"
              mat-raised-button
              style="background-color: steelblue; color: white"
            >
              Login
            </button>
          </div>
        </form>
      </div>
      <hr>
      <div>
          <label style="font-size: 14px;">Forgot password?&nbsp;</label>
          <span ><a [routerLink]="['/forgetpassword']" mat-menu-item><span style="font-size: 14px;">Recover</span></a></span>
        </div>
    </mat-card-content>
  </mat-card>
  </div>


<div *ngIf = "RouteForget">
<app-forgpt-password></app-forgpt-password>
</div>

